import React from 'react';

import styles from './Navigation.module.scss';

const Navigation = (props) => (
  <div className={styles.Navigation} ref={ props.callbackRef }>
    <div className={styles.Navigation__wrapper}>
      <a href="#experience" className={props.activeNav === 'experience' ? 'active-nav' : ''}>The Experience</a>
      <a href="#destinations" className={props.activeNav === 'destinations' ? 'active-nav' : ''}>The Destinations</a>
      <a href="#faq" className={props.activeNav === 'faq' ? 'active-nav' : ''}>FAQ</a>
    </div>
  </div>
)

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Program/Navigation/index.js